var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { LoadMoreEntries } from '../state/actions/commands';
import { Store } from '@ngxs/store';
import { DriveState } from '../state/drive-state';
import { InfiniteScroll } from 'common/core/ui/infinite-scroll/infinite.scroll';
var DriveInfiniteScrollDirective = /** @class */ (function (_super) {
    __extends(DriveInfiniteScrollDirective, _super);
    function DriveInfiniteScrollDirective(el, store) {
        var _this = _super.call(this) || this;
        _this.el = el;
        _this.store = store;
        return _this;
    }
    DriveInfiniteScrollDirective.prototype.loadMoreItems = function () {
        var page = this.store.selectSnapshot(DriveState.currentPage) + 1;
        this.store.dispatch(new LoadMoreEntries({ page: page }));
    };
    DriveInfiniteScrollDirective.prototype.isLoading = function () {
        return this.store.selectSnapshot(DriveState.loading);
    };
    DriveInfiniteScrollDirective.prototype.canLoadMore = function () {
        return this.store.selectSnapshot(DriveState.canLoadMoreEntries);
    };
    return DriveInfiniteScrollDirective;
}(InfiniteScroll));
export { DriveInfiniteScrollDirective };
